import styled, { css } from 'styled-components';
import { Modal as AntdModal } from 'antd';

export const Modal = styled(AntdModal)`
  .ant-modal-content {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.05);
    border-radius: 24px;
  }

  .ant-modal-body {
    padding: 32px;

    @media (max-width: 500px) {
      padding: 16px;
    }
  }

  .ant-modal-close-x {
    width: 48px;
    height: 48px;
  }

  @media (max-width: 500px) {
    max-width: 312px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;

  img {
    width: 28px;
    height: 28px;
  }

  @media (max-width: 500px) {
    margin-bottom: 4px;

    img {
      width: 18px;
      height: 18px;
    }
  }
`;

export const Title = styled.p`
  ${({ theme }) => css`
    font-weight: 700;
    font-size: 3.2rem;
    line-height: 3.8rem;
    color: ${theme.colors.statusWarning20};

    @media (max-width: 500px) {
      font-size: 2rem;
      line-height: 3rem;
    }
  `}
`;

export const Content = styled.p`
  ${({ theme }) => css`
    font-weight: 400;
    font-size: 2rem;
    line-height: 3rem;
    color: ${theme.colors.neutralDark80};
    margin-bottom: 16px;

    @media (max-width: 500px) {
      font-size: 1.4rem;
      line-height: 2.2rem;
    }
  `}
`;

export const Button = styled.button`
  ${({ theme }) => css`
    display: block;
    border-radius: 4px;
    min-width: 134px;
    padding: 12px 16px;
    cursor: pointer;
    transition: 300ms;
    background: ${theme.colors.statusWarning20};
    color: ${theme.colors.globalWhite100};
    margin-left: auto;

    font-weight: 600;
    font-size: 18px;

    border: none;

    &:hover {
      filter: brightness(1.25);
    }

    @media (max-width: 500px) {
      width: 100%;
    }
  `}
`;
